import { api } from "@/api"

export const retrieveProduct = async (
  productId: string
): Promise<ListProductsResponseItem> => {
  const response = await api.get<ListProductsResponseItem>(
    `/products/products/${productId}`
  )
  return response.body
}
